import { MapPin, Star } from "lucide-react";

const TESTIMONIALS = [
  { id: "janelle-bethesda", name: "Janelle R.", city: "Bethesda, MD", quote: "Honestly the cleanest service call I've ever had. They protected every floor and showed before/after photos. Allergies are noticeably better." },
  { id: "marcus-arlington", name: "Marcus T.", city: "Arlington, VA", quote: "Quoted fair, arrived early, did not upsell. The dryer vent alone made laundry 40% faster. Will book yearly." },
  { id: "priya-dc", name: "Priya S.", city: "Washington, DC", quote: "Our 1920s condo had decades of dust in the ducts. The team treated the place with care — felt like a wellness service, not a contractor." },
];

const STARS = ["s1", "s2", "s3", "s4", "s5"];

export default function TestimonialsSection() {
  return (
    <section className="section-pad bg-surfaceAlt" data-testid="testimonials-section">
      <div className="max-w-7xl mx-auto">
        <div className="eyebrow mb-3">From our neighbors</div>
        <h2 className="font-heading text-4xl md:text-5xl tracking-tight font-medium mb-12">
          Real reviews from MD, DC & VA.
        </h2>
        <div className="grid grid-cols-1 md:grid-cols-3 gap-6">
          {TESTIMONIALS.map((t) => (
            <div key={t.id} className="card-surface p-8" data-testid={`testimonial-${t.id}`}>
              <div className="flex gap-1 mb-4">
                {STARS.map((sid) => <Star key={sid} size={14} className="text-clay fill-clay" />)}
              </div>
              <p className="text-ink/85 leading-relaxed">"{t.quote}"</p>
              <div className="mt-6 text-sm">
                <div className="font-medium text-ink">{t.name}</div>
                <div className="text-muted2 flex items-center gap-1.5"><MapPin size={12} /> {t.city}</div>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}
